// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3F_cv","colMin":"styles_colMin__2wVHO","colCheckbox":"styles_colCheckbox__1_WMA"};